<template>
    <ul class="setting-box">
        <li>
            <div class="setting-content">
                <div tkey="聲音">
                    {{i18n.tkey("lang_sound")}}
                </div>

                <div>
                    <el-switch v-model="userInfoRef.openSound" @click="clickAudio" />
                </div>
            </div>
        </li>

        <li>
            <div class="setting-content">
                <div tkey="視角切換">
                    {{i18n.tkey("lang_toggle_views")}}
                </div>

                <div class="percent-50">
                    <el-select v-model="userInfoRef.CameraPerspective" @change="changeCameraPerspectiveSetting" :placeholder="i18n.tkey('lang_select_pls')" size="large">
                        <el-option
                                :key="'1'"
                                :label="i18n.tkey('lang_first_person')"
                                :value="'1'"
                        />

                        <el-option
                                :key="'3'"
                                :label="i18n.tkey('lang_third_person')"
                                :value="'3'"
                        />
                    </el-select>
                </div>
            </div>
        </li>

<!--        <li>-->
<!--            <div class="setting-content">-->
<!--                <div tkey="指引">-->
<!--                    {{i18n.tkey("lang_guide_text")}}-->
<!--                </div>-->

<!--                <div>-->
<!--                    <el-button type="primary" plain @click="clickGuide" tkey="查看">{{i18n.tkey("lang_check")}}</el-button>-->
<!--                </div>-->
<!--            </div>-->
<!--        </li>-->

        <li>
            <div class="setting-content">
                <div tkey="語言">
                    {{i18n.tkey("lang_lang")}}
                </div>

                <div>
                    <langSelect />
                </div>
            </div>
        </li>

        <li>
            <div class="setting-content">
                <div tkey="移動速度">
                    {{i18n.tkey("lang_move_speed")}}
                </div>

                <div>
                    <moveSpeedSelect />
                </div>
            </div>
        </li>

        <li v-if="true === mobileFlag">
            <div class="setting-content">
                <div tkey="操作方式">
                    {{i18n.tkey("lang_operation_method")}}
                </div>

                <div>
                    <el-select v-model="methodName" @change="changeViewMode" :placeholder="i18n.tkey('lang_select_pls')">
                        <el-option
                                :key="'normal'"
                                :label="i18n.tkey('lang_normal_text')"
                                :value="'normal'"
                        />

                        <el-option
                                :key="'watch'"
                                :label="i18n.tkey('lang_free_perspective')"
                                :value="'watch'"
                        />
                    </el-select>
                </div>
            </div>
        </li>

        <li>
            <div class="setting-content">
                <div>
                    <span tkey="店員性別">{{i18n.tkey("lang_shopman_sex")}}</span>：
                </div>

                <div>
                    <el-select v-model="userInfoRef.shopmanSex" @change="changeShopmanSex" class="m-2" :placeholder="i18n.tkey('lang_shopman_sex')" size="large">
                        <el-option
                            :key="null"
                            :label="i18n.tkey('lang_no_setting')"
                            :value="null"
                        />

                        <el-option
                            :key="0"
                            :label="i18n.tkey('lang_male')"
                            :value="0"
                        />

                        <el-option
                            :key="1"
                            :label="i18n.tkey('lang_female')"
                            :value="1"
                        />
                    </el-select>
                </div>
            </div>

        </li>

        <li class="col-9-li" style="text-align: center; margin-top: 30px">
            <el-button size="large" type="danger" @click="logoutFunc" tkey="退出登錄">{{i18n.tkey('lang_log_out_2')}}</el-button>
        </li>
    </ul>
</template>

<script setup>
    import {getCurrentInstance, toRef, inject, ref, onBeforeMount, onMounted } from 'vue'
    import { useUserinfo } from '@/stores/userinfo'
    import langSelect from "@/components/shopopee/common/langSelect"
    import moveSpeedSelect from "@/components/shopopee/common/moveSpeedSelect"
    import myUtil from "@/util/util";
    import {ElMessage, ElMessageBox} from "element-plus";
    import cookie from "@/util/cookie";

    const { changeCameraPerspective, getOperateMode, setOperateMode } = inject('threeCityFunc', { changeCameraPerspective: () => {}, getOperateMode: () => { return "normal" }, setOperateMode: () => {} })
    const { getHallOperateMode, setHallOperateMode } = inject('threeHallFunc', { getHallOperateMode: () => { return "normal" }, setHallOperateMode: () => { } })

    const emits = defineEmits(['openGuide','clickAudio', 'logout-complete'])
    const props = defineProps(['materialObj'])

    const userinfo = useUserinfo()
    const userInfoRef = toRef(userinfo)

    let { proxy } = getCurrentInstance();

    let mobileFlag = ref(false)
    const i18n = inject("i18n")

    const methodName = ref("normal")

    function clickGuide() {
        emits('openGuide')
    }
	
	function clickAudio() {
        emits('clickAudio')
	}
	
	function changeCameraPerspectiveSetting() {
        changeCameraPerspective()
    }

    function changeViewMode(value){
        setOperateMode(value)
        setHallOperateMode(value)
    }

    function changeShopmanSex() {
        ElMessageBox.confirm('修改店員性別需要重新加載頁面後才會生效，現在是否重新加載？', {
            confirmButtonText: "確定",
            cancelButtonText: "取消",
        })
            .then(() => {
                // location.reload()
                window.location.reload(true)
            })
            .catch(() => {
                // catch error
            })
    }

    function logoutFunc(){
        ElMessageBox.confirm('確定要退出登錄嗎？', {
            confirmButtonText: "確定",
            cancelButtonText: "取消",
        })
            .then(() => {
                logoutAccount()

                emits("logout-complete")

                ElMessage({
                    showClose: true,
                    message: '已退出登錄',
                    type: 'success',
                })


            })
            .catch(() => {
                // catch error
            })
    }

    //退出登錄方法
    function logoutAccount(){
        const obj = cookie.getCookie()

        for (const key in obj){
            cookie.removeCookie(key)
            cookie.removeCookie(key, {path: '/'})
        }

        const invCode = userInfoRef.value.invCode

        const lang = userInfoRef.value.lang

        const positionX = userInfoRef.value.positionX
        const positionZ = userInfoRef.value.positionZ
        const selectCountry = userInfoRef.value.selectCountry

        userInfoRef.value.$reset()

        userInfoRef.value.lang = lang

        userInfoRef.value.invCode = invCode

        userInfoRef.value.positionX = positionX
        userInfoRef.value.positionZ = positionZ
        userInfoRef.value.selectCountry = selectCountry
    }

    onBeforeMount(() => {
        methodName.value = getOperateMode()
        methodName.value = getHallOperateMode()
    })

    onMounted(() => {
        mobileFlag.value = myUtil.isMobile()
    })
</script>

<style scoped>
    ul {
        list-style: none;
        margin: 0;
        padding-left: 0;
    }

    .setting-box {
        width: 100%;
        height: 100%;
    }

    .setting-box .setting-content {
        display: flex;
        padding: 10px;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        width: 100%;
        padding-left: 20px;
        padding-right: 30px;
        border-bottom: 1px #dfdfdf solid;
    }

    .setting-box .setting-content:nth-child(even) {
        background: #f9f9f9;
    }

    .percent-50 {
        //width: 50%;
    }
</style>